import { Component, OnInit } from '@angular/core';
import { DynamicComponentBase, IDynamicComponentConfig } from '../../../dynamic-component';

@Component({
  selector: 'app-d-string-config',
  templateUrl: './d-string-config.component.html',
  styles: []
})
export class DStringConfigComponent extends DynamicComponentBase implements OnInit {
  static KEY = 'd-string-config';

  constructor() {
    super();
  }

  configChange(config: IDynamicComponentConfig) {
    // if (!Array.isArray(config.value)) {
    //   config.value = [];
    // }
  }

  ngOnInit() {}
}
